import { Component, OnInit, Signal, effect, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { PostgenieProcessComponent } from "../prompt-process/postgenie-process.component";
import { StateService } from "projects/shared-state/lib/state.service";
import { WorkflowState } from "projects/shared-state/public-api";
import { StateModule } from "projects/shared-state/lib/state.module";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, map } from "rxjs";
import {
  AppProfile,
  WorkflowData,
} from "projects/shared-state/lib/types/types";
import { AiHubLoaderService } from "@aihub/ui/loader";
import { toSignal } from "@angular/core/rxjs-interop";
import { UtilsService } from "projects/shared-new/src/lib/utils/utils.service";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { DeletePopUpComponent } from "./delete-pop-up/delete-pop-up.component";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  standalone: true,
  selector: "postgenie-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  imports: [
    CommonModule,
    StateModule,
    MatIconModule,
    MatMenuModule,
    DeletePopUpComponent,
    MatTooltipModule,
  ],
})
export class PostgenieHomeComponent implements OnInit {
  dialog = inject(MatDialog);
  stateService = inject(StateService);
  router = inject(Router);
  loaderService = inject(AiHubLoaderService);
  utilsService = inject(UtilsService);
  isLoading$ = toSignal(this.loaderService.loader$);

  currentUrl: Observable<string>;
  stateSignal$: Signal<{
    workflow: WorkflowState;
  }> = this.stateService.getAppState();

  constructor(private activeRoute: ActivatedRoute) {
    this.currentUrl = this.activeRoute.url.pipe(
      map((segments) => "/" + segments.join("/")),
    );
    effect(() => {
      const appProfile: AppProfile =
        this.stateSignal$().workflow.profile?.appProfile;
      if (!appProfile) {
        this.navigateTo("profile");
      }
    });
  }

  ngOnInit(): void {
    this.stateService.geSubscriptionApi();
    this.stateService.getProfileApi();
  }

  navigateTo(route: string, queryParam: Object = {}): void {
    this.router.navigate([route], {
      queryParams: queryParam,
      queryParamsHandling: "merge",
    });
  }

  openWorkflow(workflow: WorkflowData | undefined): void {
    if (workflow && ["done", "review"].includes(workflow.status)) {
      this.navigateTo("post", { workflow_id: workflow.uid });
    } else {
      var workflowId: string | undefined = undefined;
      if (workflow) {
        workflowId = workflow.uid;
      }
      const dialogRef = this.dialog.open(PostgenieProcessComponent, {
        width: "80%",
        height: "80%",
        data: {
          workflowId: workflowId,
        },
      });
      dialogRef.afterClosed().subscribe((reason: string | undefined) => {
        if (!reason?.includes("final post")) {
          this.stateService.saveWorkflow(
            {
              ...this.stateSignal$().workflow.workflow,
              name: this.getNameOutOfJsonString(
                this.stateSignal$().workflow.workflow.promptWorkflow.aiResults
                  .postDescription,
                "post_name",
              ),
            },
            this.stateSignal$().workflow.workflow.uid,
          );
        } else if (reason == "final post") {
          this.navigateTo("post", {
            workflow_id: this.stateSignal$().workflow.workflow.uid,
          });
        }
      });
    }
  }

  deleteWorkflow(workflow: WorkflowData | undefined): void {
    this.dialog.open(DeletePopUpComponent, {
      data: {
        workflowId: workflow.uid,
        workflowTitle: workflow.name,
      },
    });
  }

  getNameOutOfJsonString(inputJson: string, key: string): string {
    try {
      const jsonString = this.utilsService.cleanJsonString(inputJson);
      return JSON.parse(jsonString)[key];
    } catch (error) {
      return "New LinkedIn Post";
    }
  }

  createNewWorkflow(): void {
    this.stateService.createWorkflow();
    this.openWorkflow(undefined);
  }
}
